/** @format */
import TimerEventDict from './TimerEventDict';
import { TimerEventEnum } from '../Enum/TimerEventEnum';
import { TimerManagerDispatchEventEnum } from '../Enum/TimerManagerDispatchEventEnum';
import { TimerManagerSubscribeEventEnum } from '../Enum/TimerManagerSubscribeEventEnum';

export default class TimerEvent {
    private events: { [key: string]: Array<(data: any) => void> };

    private static instance: TimerEvent;

    // eslint-disable-next-line no-useless-constructor
    private constructor() {
        /**/
        this.events = {};
    }

    public static getInstance(): TimerEvent {
        if (!TimerEvent.instance) {
            TimerEvent.instance = new TimerEvent();
        }

        return TimerEvent.instance;
    }

    public dispatch = (
        event: TimerEventEnum | TimerManagerDispatchEventEnum | TimerManagerSubscribeEventEnum,
        data: TimerEventDict,
        callback?: (e?: any) => any
    ): void => {
        if (!this.events[event]) {
            return;
        }
        for (const key in this.events[event]) {
            data.name = event;
            if (!callback) {
                callback = (): any => {
                    /**/
                };
            }
            data.callback = callback;
            this.events[event][key](data);
        }
    };
    public subscribe = (
        event: TimerEventEnum | TimerManagerDispatchEventEnum | TimerManagerSubscribeEventEnum,
        callback: (data: TimerEventDict) => void
    ): void => {
        if (!this.events[event]) {
            this.events[event] = [];
        }

        this.events[event].push(callback);
    };
}
